import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { themes, fonts } from '../themes/themes';
import { useTranslate } from '../../hooks';

const DashboardCurrentTimer = () => {
  const [time, setTime] = useState('');
  const { translate } = useTranslate();

  useEffect(() => {
    currentTime();
  }, []);

  const currentTime = () => {
    const currentDate = new Date();
    const currentTime = currentDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
    setTime(currentTime);
  };
  setInterval(currentTime, 30000);

  return (
    <Typography
      style={{
        color: themes.defaultSuccess,
        textAlign: 'center',
        fontFamily: fonts.fontFamily,
        fontWeight: 'bolder',
        fontSize: '30px',
        textShadow: '0px 1px 1px #00000029',
        opacity: '1',
      }}
    >
      {time.slice(0, 6)} {translate(time.slice(6))}
    </Typography>
  );
};
export default DashboardCurrentTimer;
